import { __decorate } from "tslib";
import { Component, Vue, Prop } from 'vue-property-decorator';
import langMsg from '../../../lang/index';
import { router, pageNum, fromPage } from '@blade-sxp/search-center/interfaces/enum';
import { eventTypes } from '@blade-sxp/search-center/api/index';
let SearchCenter = class SearchCenter extends Vue {
    linkList;
    defaultTime;
    langeName;
    seachTypes(val) {
        const param = {
            page: 1,
            size: pageNum.PAGE_NUM,
            eventTypeRequest: { eventTypes: [val] },
            dateEnd: this.defaultTime[1],
            dateStart: this.defaultTime[0],
        };
        eventTypes(param).then((res) => {
            this.$router.push({ path: router.SEARCH_REULIT, query: { list: res, type: fromPage.EVENT_PAGE } });
        });
    }
};
__decorate([
    Prop()
], SearchCenter.prototype, "linkList", void 0);
__decorate([
    Prop()
], SearchCenter.prototype, "defaultTime", void 0);
__decorate([
    Prop()
], SearchCenter.prototype, "langeName", void 0);
SearchCenter = __decorate([
    Component({
        name: 'SearchTag',
        components: {},
        i18n: {
            sharedMessages: langMsg,
        },
    })
], SearchCenter);
export default SearchCenter;
